"use client";

import { CSSProperties, useState } from "react";
import FeedbackStar from "@/components/feedback_star";
import Feedback from "@/components/feedback_sr";
import { fetchFeedbackSubmit } from "@/apis/feedback/feedback.api";
import UKToast from "@/components/UKToast";
import { useTranslation } from "@/i18n/client";

interface PropsType {
  scoreNum?: number;
  onClickStar?: (item: number) => void;
  onClose?: () => void;
  containerStyle?: CSSProperties;
  shouldReportStarScore?: boolean;
  maxScoreForOpenFeedback: number; // 星级评分低于此分数就要打开feedback窗口
  title: string;
  k: string | undefined; // 搜索关键字
}

const StartFeedBack = ({ k, maxScoreForOpenFeedback, title }: PropsType) => {
  const [score, setScore] = useState(10);
  const [show, setShow] = useState(true);
  const {t} = useTranslation();
  return (
    <>
      {show && (
        <FeedbackStar
          title={title}
          containerStyle={feedbackStarStyle}
          shouldReportStarScore={true}
          sourceType={2}
          onClickStar={async (score) => {
            setScore(score);
            // 是高评分自动上报分数
            if (score > maxScoreForOpenFeedback) {
              const res = await fetchFeedbackSubmit({ sourceType: 2, platform: 3, starScore: score, extMap: { QUERY: k } });
              if (res && res.success) {
                UKToast.show({
                  icon: "success",
                  content: t("feedback.ThanksForYourFeedback"),
                });
              } else {
                UKToast.show({
                  icon: "fail",
                  content: t("common.message.tryAgain"),
                });
              }
            }
            setTimeout(() => {
              setShow(false);
            }, 1000);
          }}
        />
      )}
      {score <= maxScoreForOpenFeedback && <Feedback sourceType={2} open={true} score={score} k={k} />}
    </>
  );
};
export default StartFeedBack;

const feedbackStarStyle: CSSProperties = {
  width: "360px",
  position: "fixed",
  bottom: "20px",
  right: "20px",
  zIndex: 9999,
  padding: "24px",
  backgroundColor: "#fff",
  border: "1px solid #0000000F",
  borderRadius: "8px",
  boxShadow: "0px 4px 16px 0px #00000026",
};
